<form
  [formGroup]="otpForm"
  class="container-details flex flex-col items-center p-4 w-full max-w-md"
  (ngSubmit)="onSubmit()"
>
  <!-- Heading -->
  <div
    class="otp-heading-details flex justify-center items-center flex-col gap-2 text-center"
  >
    <p class="otp-heading text-xl font-bold">OTP Verification</p>
    <p class="text-gray-600 text-sm">
      Enter the one-time password sent to<br />
      <strong>{{ email }}</strong> 
    </p>
  </div>

  <!-- OTP Input Fields -->
  <div
    class="otp-details flex w-full items-center justify-between mt-6 space-x-2"
  >
    <input
      class="otp-input border-none outline-none bg-transparent text-center text-lg w-10 h-12 rounded-md"
      #otpInput
      type="text"
      maxlength="1"
      (input)="moveToNext($event, 0)"
      (keydown)="moveToPrevious($event, 0)"
      (paste)="onPaste($event)"
    />
    <input
      class="otp-input border-none outline-none bg-transparent text-center text-lg w-10 h-12 rounded-md"
      #otpInput
      type="text"
      maxlength="1"
      (input)="moveToNext($event, 1)"
      (keydown)="moveToPrevious($event, 1)"
    />
    <input
      class="otp-input border-none outline-none bg-transparent text-center text-lg w-10 h-12 rounded-md"
      #otpInput
      type="text"
      maxlength="1"
      (input)="moveToNext($event, 2)"
      (keydown)="moveToPrevious($event, 2)"
    />
    <input
      class="otp-input border-none outline-none bg-transparent text-center text-lg w-10 h-12 rounded-md"
      #otpInput
      type="text"
      maxlength="1"
      (input)="moveToNext($event, 3)"
      (keydown)="moveToPrevious($event, 3)"
    />
    <input
      class="otp-input border-none outline-none bg-transparent text-center text-lg w-10 h-12 rounded-md"
      #otpInput
      type="text"
      maxlength="1"
      (input)="moveToNext($event, 4)"
      (keydown)="moveToPrevious($event, 4)"
    />
  </div>
<!-- d jwt auth searl http api -->
  <!-- Stay Signed In Checkbox -->
  <div *ngIf="isStaySignedIn"  class="stay-signIn-main flex items-center justify-start self-start gap-2 mt-3">
    <div class="flex">
      <input type="checkbox" id="stay-signIn" formControlName="staySignedIn" />
    </div>
    <div class="stay-signIn">
      <label for="stay-signIn">Stay signed in</label>
    </div>
  </div>

  <!-- Submit Button -->
  <div class="button mt-4 w-full pointer">
    <button
      class="btn-default w-full py-2 bg-blue-500 text-white rounded-md shadow hover:bg-blue-600"
      type="submit"
    >
      {{ btnText }}
    </button>
  </div>

  <!-- Resend OTP -->
  <div class="alreadyuser mt-4 text-center pointer">
    <p>
      Didn’t receive OTP?
      <span class="text-blue-500 cursor-pointer" (click)="onResendOtp()"
        >Resend Now</span
      >
    </p>
  </div>
</form>
